<script>
    import { onMount } from "svelte";
    import Select from "svelte-select";

    import { getById, getList} from "../../api";
    import { headerDisplayStore } from "../../stores/General";
import CustomIcon from "../CustomIcon.svelte";
    import DatePicker from "./DatePicker.svelte";

    export let params = [
        {
            display_name: null,
            param_name: null,
            type: null,
            default_value: null,
            items: [],
            loading: false,
        },
    ];
    export let name;

    const paramTypes = [
        { value: "string", label: "Text" },
        { value: "number", label: "Number" },
        { value: "date", label: "Date" },
        { value: "dp_list", label: "Demand Partner" },
        { value: "iab_list", label: "IAB Category" },
        { value: "campaign_list", label: "Campaign" },
    ];

    function clear(event,i) {
     params[i].default_value = ""
     
  }
    onMount(async () => {
        for (let i = 0; i < params.length; i++) {
            let response;
            if (params[i].type === "dp_list") {
                response = await getById('demeand', params[i].default_value);
                response.data = response?.demand_partner;
            }
            if (params[i].type === "iab_list") {
                response = await getList('iab/category', 10, 1, "name", "ASC", {
                    search: params[i].default_value,
                });
            }
            if (params[i].type === "campaign_list") {
                response = await getById('campaign', params[i].default_value);
                response.data = response?.campaign;
            }
            if (response?.data) {
                params[i].items = response.data.map((item) => {
                    return {
                        value:
                            item.demand_partner_id ||
                            item.iab_category_id ||
                            item.campaign_id,
                        label: item.name,
                    };
                });
            }
        }
    });

    function addRow() {
        params.push({
            display_name: null,
            param_name: null,
            type: null,
            default_value: null,
            items: [],
            loading: false,
        });
        params = params;
    }

    function deleteRow(i) {
        params.splice(i, 1);
        params = params;
    }

    function handleDisplayName(event, i) {
        params[i].display_name = event.target.value;
    }

    function handleParamName(event, i) {
        params[i].param_name = event.target.value;
    }

    function handleType(event, i) {
        params[i].type = event.detail.value;
        params[i].items = [];
        params[i].default_value = ""
        loadData(params[i].type,i)
    }

    function handleDefaultValue(event, i) {
        params[i].default_value = event.target.value;
    }

    function handleDefaultValueSelect(event, i) {
        console.log(event.detail, i);
        params[i].default_value = event.detail.value;
    }

    function handleDefaultValueDate(event, i) {
        if (event.detail) {
            params[i].default_value = new Date(event.detail);
        }
    }

    async function loadData(query, i) {
        params[i].loading = true;
        try {
            let response;
            if (params[i].type === "dp_list") {
                response = await getList('demand', 10, 1, "name", "ASC", {
                    
                });
            }
            if (params[i].type === "iab_list") {
                response = await getList('iab/category', 10, 1, "name", "ASC", {
                    
                });
            }
            if (params[i].type === "campaign_list") {
                response = await getList('campaign', 10, 1, "name", "ASC", {
                   
                });
            }
            if (response?.data) {
                params[i].loading = false;
                params[i].items = response.data.map((item) => {
                    return {
                        value:
                            item.demand_partner_id ||
                            item.iab_category_id ||
                            item.campaign_id,
                        label: item.name,
                    };
                });
                return params[i].items;
            } else {
            params[i].loading = false;
                return [];
            }
        } catch (error) {
            headerDisplayStore.ShowError({
                title: "Server error",
                subtitle: error?.error,
            });
            params[i].loading = false;
            return [];
        }
    }
</script>

<div />
<div class="w-full">
    <div class="flex mb-1.5">
        <div class="grow strong w-full text-sm font-medium">Params</div>
    </div>
    <div class="flex mb-1.5">
        <div class="grow strong w-full text-sm font-medium">
            Display Name
        </div>
        <div class="grow strong w-full text-sm font-medium">
            Param Name
        </div>
        <div class="grow strong w-full text-sm font-medium">Type</div>
        <div class="grow strong w-full text-sm font-medium">
            Default Value
        </div>
        <div class="strong w-32" />
    </div>
    {#each Array(params.length) as _, i}
        <div class="flex mb-2">
            <div class="grow w-full">
                <div class="mr-2 h-full">
                    <input
                        type="text"
                        value={params[i]?.display_name == undefined ? "":params[i]?.display_name}
                        on:input={(event) => handleDisplayName(event, i)}
                        class="w-full h-full focus:ring-orange-500 focus:border-orange-500 sm:text-sm border-field-border-gray rounded-md"
                        min="0"
                    />
                </div>
            </div>
            <div class="grow w-full">
                <div class="mr-2 h-full">
                    <input
                        type="text"
                        value={params[i]?.param_name == undefined ? "":params[i]?.param_name}
                        on:input={(event) => handleParamName(event, i)}
                        class="w-full h-full focus:ring-orange-500 focus:border-orange-500 sm:text-sm border-field-border-gray rounded-md"
                        min="0"
                    />
                </div>
            </div>
            <div class="grow w-full">
                <div class="mr-2 h-full">
                    <Select
                        value={paramTypes.find(
                            (p) => p.value === params[i].type
                        )}
                        items={paramTypes}
                        on:select={(event) => handleType(event, i)}
                        containerStyles="height:100%; border-color:#9A9AB0; border-radius:5px;"
                    />
                </div>
            </div>
            <div class="grow w-full">
                <div class="mr-2 h-full">
                    {#if ["string", "number"].includes(params[i].type)}
                        <!-- <input
                            type={params[i].type === "string"
                                ? "text"
                                : "number"}
                            value={params[i]?.default_value == undefined ? "":params[i]?.default_value}
                            on:input={(event) => handleDefaultValue(event, i)}
                            class="w-full h-full focus:ring-orange-500 focus:border-orange-500 sm:text-sm border-field-border-gray rounded-md"
                            min="0"
                        /> -->
                        <div class="relative">
                          <input 
                          type={params[i].type === "string"
                          ? "text"
                          : "number"}
                      value={params[i]?.default_value == undefined ? "":params[i]?.default_value}
                      on:input={(event) => handleDefaultValue(event, i)}
                      min="0"
                          class="h-12 w-80 pl-8 pr-10  z-0 focus:shadow focus:ring-orange-500 focus:border-orange-500 sm:text-sm border-field-border-gray rounded-md">
                          {#if params[i]?.default_value !== undefined && params[i]?.default_value !== "" }
                              
                          <div class="absolute top-3 right-1">
                              
                              <span on:click={(event)=> clear(event,i)} class="autocomplete-clear-button">&#10006;</span>
                              
                          </div>
                          {/if}
                        </div>
                    {/if}
                    {#if ["dp_list", "iab_list", "campaign_list"].includes(params[i].type)}
                        <Select
                            value={params[i].items?.find(
                                (p) => p.value === params[i].default_value
                            )}
                            items={params[i].items}
                            loadOptions={(query) => loadData(query, i)}
                            isWaiting={params[i].loading}
                            on:select={(event) =>
                                handleDefaultValueSelect(event, i)}
                            containerStyles="height:100%; border-color:#9A9AB0; border-radius:5px;"
                        />
                    {/if}
                    {#if ["date"].includes(params[i].type)}
                        <DatePicker
                            label=""
                            initialValue={params[i].default_value || ""}
                            on:onChange={(event) =>
                                handleDefaultValueDate(event, i)}
                        />
                    {/if}
                </div>
            </div>
            {#if i === 0}
                <div class="strong w-32 self-center text-center">
                    <button
                        type="button"
                        on:click={() => {
                            addRow();
                        }}
                        class="w-12 h-12 relative inline-flex items-center justify-center px-1 py-2 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                    >
                        <!-- <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 12H4M12 20V12V20ZM12 12V4V12ZM12 12H20H12Z"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                        </svg> -->
                        <CustomIcon name="add_row" width="24" height="24"/>
                    </button>
                </div>
            {:else}
                <div class="strong w-32 self-center text-center">
                    <button
                        type="button"
                        on:click={() => {
                            deleteRow(i);
                        }}
                        class="w-12 h-12 relative inline-flex items-center justify-center px-1 py-2 rounded-md border shadow-nv border-custom-orange text-sm font-medium text-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                    >
                        <!-- <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 12H4M12 12H20H12Z"
                                stroke="fillColor"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                        </svg> -->
                        <CustomIcon name="delete_row" width="24" height="24" color="#F78907" />
                    </button>
                </div>
            {/if}
        </div>
    {/each}
    <input
        value={JSON.stringify(
            params
                .filter((param) => param.param_name)
                .map((param) => {
                    return {
                        display_name: param.display_name,
                        param_name: param.param_name,
                        type: param.type,
                        default_value: param.default_value,
                    };
                })
        )}
        {name}
        type="text"
        class="invisible w-0 h-0 p-0 m-0 border-0"
    />
</div>